'use server'

/**
 * Server Actions for LLM Preference
 *
 * 아바타 채팅의 텍스트 메시지는 Voice Server를 경유해 백엔드에 도착하므로
 * provider/model_id를 메시지에 실을 수 없습니다. 대신 이 액션으로
 * "이 session_id는 이 모델 사용"을 백엔드(Redis)에 미리 등록합니다.
 *
 * 공개 페이지([slug])에서는 로그인이 없으므로 public_expo_user로 등록합니다.
 */

import { auth } from '@clerk/nextjs/server'

const NEXT_PUBLIC_BACKEND_URL =
  process.env.NEXT_PUBLIC_BACKEND_URL || 'http://backend:8500'

interface LlmPreferenceResult {
  success: boolean
}

/**
 * 세션별 LLM 선호 등록 (best-effort: 실패해도 채팅은 기본 모델로 동작)
 */
export async function registerLlmPreference(
  agentId: string,
  sessionId: string,
  provider: string,
  modelId: string
): Promise<LlmPreferenceResult> {
  const { userId } = await auth()
  const effectiveUserId = userId || 'public_expo_user'

  try {
    const response = await fetch(
      `${NEXT_PUBLIC_BACKEND_URL}/api/agents/${agentId}/llm-preference`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${effectiveUserId}`,
          'X-User-Id': effectiveUserId,
        },
        body: JSON.stringify({
          session_id: sessionId,
          provider,
          model_id: modelId,
        }),
      }
    )

    if (!response.ok) {
      console.error(
        `[LLM Preference] 등록 실패: ${response.status} ${await response.text()}`
      )
      return { success: false }
    }

    return { success: true }
  } catch (error) {
    console.error('[LLM Preference] 등록 오류:', error)
    return { success: false }
  }
}
